import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import _ from 'lodash';
import FormRadioGroup from '../../components/form/FormRadioGroup/FormRadioGroup';

const FormRadioGroupContainer = props =>
  <Field
    name={props.name}
    component={FormRadioGroup}
    props={props}
  />
;

const mapStateToProps = (state, ownProps) => {
  if (state.form.checkout.values) {
    return { selectedId: _.get(state.form.checkout.values, ownProps.name), props: ownProps };
  }

  return { props: ownProps };
};

FormRadioGroupContainer.propTypes = {
  name: PropTypes.string
};

export default connect(mapStateToProps)(FormRadioGroupContainer);



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormRadioGroupContainer.js
 **/